import { call, takeEvery } from 'typed-redux-saga';

import { countMetrika } from '../../../shared/helpers/metrika';
import { ARTIFACTS_FILTER_OPTION, DATE_RANGE_TYPE } from '../constants';
import { setFilterArtifacts, setFilterDateRangeType } from '../features/filter/slice';

const DATE_RANGE_TYPE_TO_METRIKA_KEY = {
    [DATE_RANGE_TYPE.FOR_3_MONTH]: '3month_period',
    [DATE_RANGE_TYPE.SPECIFIC_MONTH]: '1month_period',
    [DATE_RANGE_TYPE.SPECIFIC_DATE]: '1day_period',
    [DATE_RANGE_TYPE.SPECIFIC_DATES]: 'chosen_period',
} as Record<DATE_RANGE_TYPE, string>;

const ARTIFACTS_FILTER_OPTION_TO_METRIKA_KEY = {
    [ARTIFACTS_FILTER_OPTION.ALL_CONFS]: 'all_meeting',
    [ARTIFACTS_FILTER_OPTION.WITH_RECORDING]: 'meeting_with_record',
    [ARTIFACTS_FILTER_OPTION.WITH_SUMMARY]: 'meeting_with_summary',
    [ARTIFACTS_FILTER_OPTION.WITH_REPORT]: 'meeting_with_participation_report',
} as Record<ARTIFACTS_FILTER_OPTION, string>;

export function* metrikaSaga() {
    yield* takeEvery(setFilterDateRangeType, function* ({ payload }) {
        yield* call(countMetrika, 'meeting_history', 'date_period_filter', DATE_RANGE_TYPE_TO_METRIKA_KEY[payload]);
    });
    yield* takeEvery(setFilterArtifacts, function* ({ payload }) {
        yield* call(
            countMetrika,
            'meeting_history',
            'meeting_info_filter',
            ARTIFACTS_FILTER_OPTION_TO_METRIKA_KEY[payload]
        );
    });
}
